import type { FocusEvent } from 'react';

import {
  NumberInput,
  NumberInputField,
  SelectComponents,
} from '@frontend/legacy-components';

import { capitalize } from 'utils/stringUtils';

import PeriodPicker from './PeriodPicker';
import type {
  AmountAndUnitRelationFilterValue,
  ExcludableDateRelation,
} from './types';
import { TimeUnitPlural } from './types';

const RightPeriodSelectControl = (props) => (
  <SelectComponents.Control
    {...props}
    innerProps={{
      ...props.innerProps,
      borderLeftRadius: 0,
    }}
  />
);

const PERIOD_OPTIONS_NON_CURRENT = Object.values(TimeUnitPlural).map(
  (period) => ({
    value: period,
    label: capitalize(period),
  }),
);

export type AmountAndUnitInputProps<
  ExcludedRelations extends ExcludableDateRelation,
> = {
  relationFilterValue: AmountAndUnitRelationFilterValue<ExcludedRelations>;
  onAmountChange: (newAmount: string) => void;
  onUnitChange: (newUnit: TimeUnitPlural) => void;
  isPopoverOverlayEnabled?: boolean;
};

const AmountAndUnitInput = <ExcludedRelations extends ExcludableDateRelation>({
  relationFilterValue,
  onAmountChange,
  onUnitChange,
  isPopoverOverlayEnabled = false,
}: AmountAndUnitInputProps<ExcludedRelations>) => {
  return (
    <>
      <NumberInput
        name="amount"
        value={relationFilterValue.amount}
        onChange={onAmountChange}
        onBlur={(event: FocusEvent<HTMLInputElement>) => {
          const newAmount = event.target.value;

          onAmountChange(newAmount);
        }}
      >
        <NumberInputField borderRadius={0} borderRight={0} />
      </NumberInput>
      <PeriodPicker
        isPopoverOverlayEnabled={isPopoverOverlayEnabled}
        onChange={(
          selectedOption: (typeof PERIOD_OPTIONS_NON_CURRENT)[number],
        ) => {
          const { value: selectedUnit } = selectedOption;

          onUnitChange(selectedUnit);
        }}
        value={PERIOD_OPTIONS_NON_CURRENT.find(
          (option) => option.value === relationFilterValue.unit,
        )}
        components={{
          Control: RightPeriodSelectControl,
        }}
        options={PERIOD_OPTIONS_NON_CURRENT}
      />
    </>
  );
};

export default AmountAndUnitInput;
